import React from "react";
import { Phone, MapPin, Mail } from "lucide-react";
import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function ServiceArea() {
  const { ref, visible } = useScrollReveal();

  return (
    <section id="service-area" className="bg-[hsl(var(--poured))] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={ref}
          className={`grid lg:grid-cols-2 gap-12 items-center transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          {/* Map graphic */}
          <div className="relative bg-[hsl(var(--navy))] rounded-sm overflow-hidden h-[400px] md:h-[480px] concrete-texture">
            <div className="absolute inset-0 rebar-trace opacity-40" />
            {/* Stylized Arkansas map shape */}
            <svg
              viewBox="0 0 400 320"
              className="absolute inset-0 w-full h-full p-12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M30 60 L90 50 L150 55 L210 48 L280 52 L350 58 L360 120 L355 180 L345 240 L280 250 L210 255 L150 248 L90 252 L35 245 L25 180 Z"
                fill="hsl(var(--accent))"
                fillOpacity="0.12"
                stroke="hsl(var(--accent))"
                strokeWidth="2"
                strokeDasharray="6 4"
              />
              {/* NWA highlight region */}
              <circle cx="75" cy="120" r="40" fill="hsl(var(--accent))" fillOpacity="0.3" />
              <circle cx="75" cy="120" r="18" fill="hsl(var(--accent))" />
              <text
                x="75"
                y="125"
                textAnchor="middle"
                fill="white"
                fontSize="11"
                fontFamily="monospace"
                fontWeight="700"
              >
                NWA
              </text>
              <text
                x="200"
                y="160"
                textAnchor="middle"
                fill="hsl(var(--accent))"
                fillOpacity="0.5"
                fontSize="14"
                fontFamily="monospace"
                fontWeight="700"
                letterSpacing="2"
              >
                ARKANSAS
              </text>
            </svg>
            <div className="absolute bottom-4 left-4 flex items-center gap-2 text-white/60 text-xs font-mono">
              <MapPin size={14} className="text-[#194d32]" />
              479 AREA
            </div>
          </div>

          {/* Content */}
          <div>
            <div className="inline-flex items-center gap-2 mb-4">
              <div className="w-8 h-0.5 bg-[#434951]" />
              <span className="section-label text-[#194d32] text-base">
                Based in Springdale
              </span>
            </div>
            <h2 className="headline text-[hsl(var(--navy))] text-3xl sm:text-4xl md:text-5xl mb-5">
              Based in Springdale. Proudly Serving Northwest Arkansas
            </h2>
            <p className="text-[hsl(var(--charcoal))]/80 text-base sm:text-lg leading-relaxed mb-8">
              Based in Springdale, Arkansas, NCC provides professional concrete
              construction services for residential and commercial projects
              throughout Northwest Arkansas and surrounding communities.
            </p>

            {/* Not sure callout */}
            <div className="bg-[hsl(var(--navy))] rounded-sm p-6 rebar-trace">
              <p className="text-white/80 text-sm mb-3">
                Not sure if we service your area?
              </p>
              <a
                href="mailto:naturalconcrete.contruction@gmail.com"
                className="flex items-center gap-2 font-heading text-2xl tracking-wider hover:text-white transition-colors focus-ring rounded text-[#194d32]"
              >
                <Mail size={22} />
                naturalconcrete.contruction@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}